import React from "react";
import { removeUser } from "../../../components/shared/utils";
import { Button } from "reactstrap";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import * as loaderAction from "../../../redux/loader/action";
import Cross from "../../../assets/images/verboden/cross.png";
import TrippleArrows from "../../../assets/images/verboden/trippleArrows.png";
import cx from "classnames";
import { connect } from "react-redux";
import Socket from "../../../socket/socket";

class PlayerCard extends React.Component {
  constructor(props) {
    super(props);
  }

  delPlayer = async (data) => {
    let roomObj = this.props.gameReducer.roomObj;
    await removeUser(roomObj, data);
  };
  arrowClick = (data) => {
    console.log('call arrow clickkkk');
    // const { isLoading } = this.props.loaderDetails;
    // this.props.setChangingTeam(true);
    const { gameReducer } = this.props;
    const roomData = gameReducer.roomObj;
    let obj = {
      action: "change-team-vb",
      roomId: roomData.id,
      playerId: data.player_id,
    };
    Socket.sendMessage(obj);
  };
  render() {
    const { data, type = "first" } = this.props;
    return (
      <>
        {data !== undefined ? (
          <div
            className={cx("team-list", {
              "flex-row-reverse": type === "second",
            })}
          >
            <Button onClick={() => this.delPlayer(data)} color="themePink">
              <img src={Cross} />
            </Button>
            <div
              className={cx("d-flex align-items-center", {
                "flex-row-reverse": type === "second",
              })}
            >
              <p className="text mb-0">
                {data && data.display_name ? data.display_name : ""}
              </p>
              <img
                src={data ? data.profile_image : ""}
                className="profile-img"
              />
              <Button color="themeGreen" onClick={() => this.arrowClick(data)}>
                <img
                  src={TrippleArrows}
                  style={type === "second" ? { transform: "scaleX(-1)" } : {}}
                />
              </Button>
            </div>
          </div>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    setChangingTeam: (data) => dispatch(loaderAction.setChangingTeam(data)),
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(PlayerCard);
